<template>
    <div class="intervention-fullscreen-main" :class="screenSize < 700 ? 'intervention-fullscreen-small': ''">
        <stepper v-if="view.id !== 'completed' && screenSize > 699" :items="navs" v-model="view" :nextDisabled="true" style="padding-bottom: 7px;"></stepper>
        <card
            :component="view.id"
            :title="view.title"
            :index="view.index"
            :complete="view.complete"
            :fastbridgeMonitor="fastbridgeMonitor"
            :preSelectedStudents="students"
            :value="value"
            @go="setComponent"
            @createNew="$emit('createNew')"
            @close="$emit('close')"
            @monitorType="setMonitorType"
            :smallScreen="screenSize < 700"
        >
        </card>
    </div>
</template>

<script>
import Stepper from './Stepper'
import Card from './Card.vue'
export default {
    name: 'FullScreenIntervention',

    components: {
        Stepper,
        Card,
    },

    props: {
        fastbridgeMonitor: {
            type: Object,
            required: false,
            default: () => {}
        },
        students: { 
            type: Array,
            default: () => []
        },
        value: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        let me = this
        return {
            navs: [{
                id: 'students',
                name: 'Students',
                index: 0,
                title: 'Add Students',
                complete: false,
            }, {
                id: 'details',
                name: 'Intervention Details',
                index: 1,
                title: 'Intervention Details',
                complete: false,
            },{
                id: 'schedule',
                name: 'Plan Schedule',
                index: 2,
                title: 'Intervention Plan Schedule',
                complete: false,
            }, {
                id: 'monitor',
                name: 'Progress Monitor',
                index: 3,
                title: 'Progress Monitoring',
                complete: false,
                hidden: false,
            },{
                id: 'review',
                name: 'Review & Create',
                index: 4,
                title: 'Review & Create Intervention',
                complete: false,
            }],
            view: [],
            screenSize: null,
            monitorType: null,
        }
    },

    mounted() {
        this.view = this.navs[0]
        this.screenSize = window.innerHeight
    },

    methods: {
        setComponent(direction) {
            if (direction === 'completed') {
                this.view = {id: 'completed', title: '', index: -1}
                this.navs.find(x => x.id === 'review').complete = true
            } else if (direction === 'continue' || direction === 'back') {
                this.view.complete = direction === 'continue' ? true : false
                let idx = direction === 'continue' ? this.view.index + 1 : this.view.index - 1
                // skip if the next screen is hidden
                this.view = this.navs.find(x => x.index === idx).hidden ? this.navs.find(x => x.index === idx + 1) : this.navs.find(x => x.index === idx)
            } else {
                this.view = this.navs.find(x => x.id === direction)
            }
        },
        setMonitorType(type) {
            this.monitorType = type
            let monitorIndex = this.navs.findIndex(x => x.id === 'monitor')
            // if participation, hide the monitor screen
            if(type === 'participation') {
               this.navs.find(x => x.id === 'monitor').hidden = true
            } else {
                this.navs.find(x => x.id === 'monitor').hidden = false
            }
            if(this.navs[monitorIndex]) {
                this.navs[monitorIndex].name = type === 'point-sheet' ? 'Point Sheet' : 'Progress Monitor'
                this.navs[monitorIndex].title = type === 'point-sheet' ? 'Point Sheet' : 'Progress Monitoring'
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.intervention-fullscreen-main {
    min-height:100%; 
    max-height:100%; 
    overflow: hidden; 
    display: flex; 
    flex-direction: column;
    color: #050F2D;

    ::v-deep .error--text {
        color: #BF0D00 !important;
    }

    ::v-deep .error--text .v-text-field__details {
        padding-left: 0 !important;
    }
}
</style>
